/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { useDashboardWidgetData } from '../../../../../hooks/useWidgetState'
import ErrorMessage from '../../../../share/ErrorMessage'
import { InsightCount } from '../../../../../schemas/action/InsightCountSchema'

const WordCloudEmptyResultGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  // NI-2615: guard the insights / dataset chain so an InsightCount with
  // missing `insights` (Prospero omits the field for empty categories) lands
  // in the friendly empty state here instead of throwing
  // `Cannot read properties of undefined (reading '0')` through the outer
  // ErrorBoundary.
  const entries =
    widgetData?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.flatMap(
      (result) => result.set ?? []
    ) ?? []

  if (entries.length === 0) return <ErrorMessage>{t('noDataFoundInWidget')}</ErrorMessage>

  return children
}

export default WordCloudEmptyResultGuard
